@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <mat-card appearance="outlined" class="card-container">
        <div class="item-row mt-3">
            <h2 class="card-title">Send Reminder</h2>
        </div>
        <div class="row item-row">
            <div class="col-2">
                Token
            </div>
            <div class="col-6">
                {{ updateToken }}
            </div>
        </div>
        <div class="row item-row">
            <div class="col-2">
                Token Expire Date
            </div>
            <div class="col-6">
                {{ dateFormat(tokenExpirationDate, userContextProvider.region, true) }} UTC
            </div>
        </div>
        <div class="row item-row">
            <div class="col-2">
                Landing Page Link
            </div>
            <div class="col-6">
                <a [href]="landingPageUrl" target="_blank">{{ landingPageUrl }}</a>
            </div>
        </div>
        <div class="row item-row">
            <div class="col-2 email-label">
                Guest Email Address <span class="red">*</span>
            </div>
            <div class="col-6">
                <mat-form-field appearance="outline" style="width:550px;">
                    <input
                        matInput
                        type="email"
                        #email="ngModel"
                        [class.is-invalid]="email.invalid && email.touched"
                        required
                        name="email"
                        [(ngModel)]="emailAddress"
                        placeholder="Enter email address"
                    />
                    <mat-error *ngIf="email.invalid">Invalid Email</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row item-row">
            <mat-checkbox [(ngModel)]="saveEmailAddress">Save this email to guest's profile</mat-checkbox>
        </div>
        <div class="row my-3">
            <div class="col-6">
                <button mat-raised-button class="action-button" (click)="sendEmail()" [disabled]="!email.valid">Resend Email to Guest</button>
            </div>
        </div>
    </mat-card>
}